import {
  useCreateBiotwinMutation,
  useUpdateBiotwinMutation,
  useUpdateBulkBiotwinConditionsMutation,
} from '../../../app/services/biotwinApi';
import {BiotwinExportData} from '../types';

export const useImportBiotwin = () => {
  const [createBiotwin] = useCreateBiotwinMutation();
  const [updateBiotwin] = useUpdateBiotwinMutation();
  const [updateBulkBiotwinConditions] = useUpdateBulkBiotwinConditionsMutation();

  const importBiotwin = async (data: BiotwinExportData, tenantId: number) => {
    try {
      const {biotwin, biotwinConditions, demographicConditionIds, selectedConditionIds} = data;
      const createdBiotwin = await createBiotwin({name: biotwin.name, tenantId}).unwrap();
      const updatedBiotwin = await updateBiotwin({
        id: createdBiotwin.id,
        changes: {
          dateOfBirth: biotwin.dateOfBirth,
          gender: biotwin.gender,
          height: biotwin.height,
          heightUnit: biotwin.heightUnit,
          note: biotwin.note,
          weight: biotwin.weight,
          weightUnit: biotwin.weightUnit,
        },
      }).unwrap();

      const selectedNonDemographicBiotwinConditions = biotwinConditions
        .filter((condition) => selectedConditionIds.includes(condition.conditionId))
        .filter((condition) => !demographicConditionIds.includes(condition.conditionId))
        .filter((condition, index, array) => array.findIndex((c) => c.conditionId === condition.conditionId) === index);

      await updateBulkBiotwinConditions({
        added: selectedNonDemographicBiotwinConditions.map((condition) => ({
          conditionId: condition.conditionId,
          // drugId: condition.drugId,
          date: condition.date ?? undefined,
          note: condition.note ?? undefined,
          // unitId: condition.unitId ?? undefined,
          value: condition.value ?? undefined,
        })),
        removedIds: [],
        userId: updatedBiotwin.id,
      }).unwrap();
    } catch (error) {
      console.error('Error importing biotwin:', error);
    }
  };

  return {importBiotwin};
};
